/**
 * Desktop sidebar width (drag its right edge). Stored per device; applied as the
 * `--sidebar-w` CSS variable, which the sidebar, the page's left padding and anything
 * positioned beside the sidebar read.
 */
export const SIDEBAR_MIN = 180
export const SIDEBAR_MAX = 420
export const SIDEBAR_DEFAULT = 224
const KEY = 'tz.sidebarW'

export const clampSidebar = (px: number) => Math.round(Math.min(SIDEBAR_MAX, Math.max(SIDEBAR_MIN, px)))

export function setSidebarWidth(px: number, persist = false) {
  const w = clampSidebar(px)
  document.documentElement.style.setProperty('--sidebar-w', `${w}px`)
  if (persist) {
    try {
      localStorage.setItem(KEY, String(w))
    } catch {
      // private mode: this session only
    }
  }
  return w
}

export function sidebarWidth(): number {
  const v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sidebar-w'))
  return Number.isFinite(v) ? v : SIDEBAR_DEFAULT
}

/** Before the first render. */
export function applyStoredSidebarWidth() {
  let w = SIDEBAR_DEFAULT
  try {
    const v = Number(localStorage.getItem(KEY))
    if (v) w = v
  } catch {
    // ignore
  }
  setSidebarWidth(w)
}
